<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17QX0Jw/tc-custom/9781401685553.jpg?1726574064410" alt="This image is the cover for the book Plain Proposal, The Daughters of the Promise Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Plain Proposal, The Daughters of the Promise Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The man she loves wants to leave the Amish faith. But can she really leave her life behind?</b></p><p><b>"Whatever he chooses, I'm going with him."</b></p><p>Miriam Raber enjoys life in her Old Order Amish community, and she is hopeful that Saul Fisher will propose to her soon. But when Saul starts talking about leaving the only world either of them has ever known, Miriam imagines what her life might look like as an <i>Englischer</i>. One thing she knows for certain, she loves Saul and feels he’s the one God has chosen for her. But Saul’s indecision has come at an inconvenient time as Miriam is noticing advances from Jesse Dienner, a man she went to school with and who wants to marry.</p><p>Complicating matters is the arrival of Miriam’s cousin, Shelby, a worldly <i>Englisch</i> girl sent to live with Miriam’s family following trouble back home.</p><p>Who will Miriam choose a life with—and who will choose to stay in the Old Order Amish community? </p><i>Sweet Amish romance, part of the Daughters of the Promise series</i><i>Book One: </i>Plain Perfect<i>, Book Two: </i>Plain Pursuit<i>, Book Three: </i>Plain Promise<i>, Book Four: </i>Plain Paradise<i>, Book Five: </i>Plain Proposal<i>, Book 6: </i>Plain Peace<i>Book length: approximately 90,000 words</i><i>Includes discussion questions for book clubs</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Wiseman
      </h2>
      
      <p class="authorDescription body article"><P>Bestselling and award-winning author Beth Wiseman has sold over two million books. She is the recipient of the coveted Holt Medallion, is a two-time Carol Award winner, and has won the Inspirational Reader's Choice Award three times. Her books have been on various bestseller lists, including CBA, ECPA, Christianbook, and <I>Publishers Weekly</I>. Beth and her husband are empty nesters enjoying country life in south-central Texas. Visit her online at BethWiseman.com; Facebook: @AuthorBethWiseman; Twitter: @BethWiseman; Instagram: @bethwisemanauthor</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9020a510